/**
 * Size helper functions
 */
class SizeUtils {
    /**
     * Get window width
     * @return {number}
     */
    static windowWidth() {
        return $(window).width();
    }
}

export { SizeUtils };
